module.exports = "/static/assets/9f4cec21dfeee10b255f0362d165d383.gif";